let _ = require('../_.js');
let $ = jQuery;

// Tracks each individual page load, and uniquely identifies the browser with a random token.

// For get_token():
let resolveToken;
let tokenPromise = new Promise((resolve) => {
    resolveToken = resolve;
});

let activity_id = null;
let _cookie = null;

_.Web_Session = class Session {

    constructor() {

    }

    static async log_activity() {
        if (_.isCrawler()) {
            return;
        }

        // Get the information for the data object
        let data = {
            user_agent: navigator.userAgent,
            token: this.get_session_cookie(),
            path: window.location.pathname,
            query: window.location.search,
            referrer: document.referrer,
            os: _.getOS(),
            is_mobile: _.isMobileDevice(),
            resolution: window.innerWidth
        };

        // try {
        // Result returns token and id.  We pass id to the websocket.
        let result = await _.backend_ajax('web_session', 'activity', data);

        // Interpret the response and update the session cookie
        if (result.token) {
            let expirationDays = 365; // 1 year
            this.set_session_cookie(result.token, expirationDays);

            activity_id = result.web_session_activity_id;

            // Subscribe to this channel to indicate we are manipulating this activity record.
            // When the connection terminates the activity will be marked complete for analytics purposes.
            _.websocket_send_subscribe("web_session", { token: result.token, session: this.get_session_cookie(), id: result.web_session_activity_id });

            // Ping every 4 minutes for keep alive.  If not seen in 10 minutes the system will assume the client is gone.
            setInterval(function () {
                _.Web_Session.ping();
            }, 4 * 60 * 1000)
            // }, 5000) // testing
        }

        // if (result.web_session_id) {
        //     // Subscribe to changes in the web_session to track if the current user is logged in or not.
        // }

        // Resolve the tokenPromise with the token value
        resolveToken(this.get_session_cookie());
    }

    static async ping() {
        // Get the information for the data object
        let data = {
            activity_id: activity_id,
            token: this.get_session_cookie(),
        };

        try {
            // Result returns token and id.  We pass id to the websocket.
            await _.backend_ajax('web_session', 'ping', data);
        } catch (e) {
            console.error(e);
        }

        // Resolve the tokenPromise with the token value
        resolveToken(this.get_session_cookie());
    }

    // returns the token.  Waits for the token to be retrieved before returning if we haven't
    // received / validated the token yet.
    static async get_token() {
        // Wait for the tokenPromise to be resolved
        return await tokenPromise;
    }

    static set_session_cookie(token, expirationDays = 30) {
        _cookie = token;
        var date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = "ws-token=" + token + "; " + expires + "; path=/";
    }

    static get_session_cookie() {
        if (_cookie) {
            return _cookie;
        }

        var name = "ws-token=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookies = decodedCookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null;
    }

    static delete_session_cookie() {
        document.cookie = "ws-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }


}
